import { render } from "./TaahodatY.vue?vue&type=template&id=0d783bce&scoped=true"
import script from "./TaahodatY.vue?vue&type=script&lang=js"
export * from "./TaahodatY.vue?vue&type=script&lang=js"

import "./TaahodatY.vue?vue&type=style&index=0&id=0d783bce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d783bce"]])

export default __exports__